// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprAcceptFree extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.accept_free";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprAcceptFree {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Acceptar i continuar gratis",
                "cs": "Přijmout a pokračovat zdarma",
                "da": "Accepter og fortsæt gratis",
                "de": "Akzeptieren und kostenlos fortfahren",
                "en": "Accept and continue for free",
                "es": "Aceptar y continuar gratis",
                "eu": "Onartu eta jarraitu doan",
                "fi": "Hyväksy ja jatka ilmaiseksi",
                "fr": "Accepter et continuer gratuitement",
                "gl": "Aceptar e continuar de balde",
                "hi": "स्वीकार करें और मुफ्त जारी रखें",
                "hu": "Elfogad és folytatás ingyenesen",
                "it": "Accetta e continua gratuitamente",
                "nl": "Accepteren en gratis doorgaan",
                "no": "Aksepter og fortsett gratis",
                "pl": "Akceptuj i kontynuuj za darmo",
                "pt": "Aceitar e continuar gratuitamente",
                "pt-BR": "Aceitar e continuar gratuitamente",
                "ro": "Acceptă și continuă gratuit",
                "ru": "Принять и продолжить бесплатно",
                "sk": "Prijať a pokračovať zadarmo",
                "sv": "Acceptera och fortsätt gratis",
                "tr": "Kabul et ve ücretsiz devam et"
            },
            "defecto": "Aceptar y continuar gratis"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
